module.exports = __webpack_public_path__ + "img/uzbekistan.1f5b43da.svg";